module.exports = __webpack_public_path__ + "static/media/na.8ca05757.svg";